import { unaryRpc } from "@redotech/rpc/definition";
import * as z from "zod";

export const getLabelPrebought = unaryRpc({
  name: "getLabelPrebought",
  input: z.object({ fulfillmentGroupId: z.string() }),
  output: z.object({ prebought: z.boolean() }),
  mock: { prebought: false },
});
